import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News6ComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-news-6",
    templateUrl: "./news-6.component.html",
    styles: [
        `
            p {
                margin-bottom: 16px;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News6Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News6ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
